// extracted by mini-css-extract-plugin
export default {"container":"Activity_container__j9PqM","title":"Activity_title__k6rhQ","researchPhase":"Activity_researchPhase__78SkP","section__header":"Activity_section__header__uJOjk"};